<template>
  <q-layout view="lHh LpR fFf" class="is-employee-shell">
    <q-header elevated class="emp-header">
      <q-toolbar class="emp-toolbar">
        <q-btn flat class="q-mr-md" @click="leftDrawerOpen = !leftDrawerOpen" aria-label="Menu" icon="fas fa-bars"
          text-color="dark">
          <q-tooltip anchor="top middle" content-class="bg-black" self="bottom middle" :offset="[20, 20]">
            <span v-if="leftDrawerOpen"><strong>Close Drawer</strong></span>
            <span v-else><strong>Open Drawer</strong></span>
          </q-tooltip>
        </q-btn>

        <div class="emp-clock">
          <p class="emp-clock-time">{{ currentTime }}</p>
          <p class="emp-clock-tz">{{ timeZone }}</p>
        </div>

        <div class="emp-header-actions" style="display: flex; margin-left: auto; margin-right: 0; align-items: center;">
          <!-- START:: Button for notifications -->
          <q-btn class="q-mr-sm" stretch flat icon="fas fa-bell" text-color="dark" style="width: 30px;" size="sm"
            @click="notificationBell">
            <q-badge class="absolute-bottom-right emp-notif-badge" v-if="count != 0" v-html="count"></q-badge>
            <q-tooltip anchor="top middle" content-class="bg-black" self="bottom middle" :offset="[10, 10]">
              <strong>Notifications</strong>
            </q-tooltip>
          </q-btn>

          <div class="emp-avatar-wrap">
            <q-avatar @click="toggleMenu" class="cursor-pointer emp-header-avatar" size="40px">
              <img @click="toggleMenu" class="emp-profile-avatar-img" :src="apiUrl + '/' + userData.image"
                alt="User Avatar"
                @error="$event.target.onerror = null; $event.target.src = '/default-profile-avatar.svg'" />
            </q-avatar>
            <q-menu v-model="showMenu" auto-close :offset="[0, 5]" transition-show="scale" transition-hide="scale"
              content-class="emp-user-menu">
              <q-list style="min-width: 200px">
                <q-item clickable @click="myProfile">
                  <div style="display: flex; justify-items: center; align-items: center; gap: 10px">
                    <i class="fa fa-user"></i>
                    <q-item-section>Profile</q-item-section>
                  </div>
                </q-item>
                <q-item clickable @click="changePassword">
                  <div style="display: flex; justify-items: center; align-items: center; gap: 10px">
                    <i class="fa fa-key"></i>
                    <q-item-section>Change Password</q-item-section>
                  </div>
                </q-item>
                <q-item clickable @click="logOut">
                  <div style="display: flex; justify-items: center; align-items: center; gap: 10px">
                    <i class="fa fa-power-off"></i>
                    <q-item-section>Logout</q-item-section>
                  </div>
                </q-item>
              </q-list>
            </q-menu>
          </div>
        </div>

      </q-toolbar>
    </q-header>
    <q-drawer side="left" elevated v-model="leftDrawerOpen" bordered class="left-panel emp-drawer" :width="300">
      <q-list class="emp-drawer-list">
        <q-item-label class="emp-drawer-profile">
          <h4 class="no-margin">
            <q-item clickable tag="a" :href="selectedModule.code === 'employee' ? undefined : '/admin/dashboard'"
              class="text-center emp-profile-item" style="display: flex; flex-direction: column;">
              <div class="full-width emp-company-name">
                <p>{{ userData.company }}</p>
              </div>
              <div class="emp-profile-avatar-wrap">
                <img class="emp-profile-avatar" width="80" height="80" :src="apiUrl + '/' + userData.image" alt=""
                  @error="$event.target.onerror = null; $event.target.src = '/default-profile-avatar.svg'">
                <p class="emp-profile-name">{{ userData.firstname }}</p>
                <p class="emp-profile-role">
                  {{ userData.role_id == 0 ? "Superadmin"
                    : userData.role_id == 1 ? "Admin"
                      : "Employee"
                  }}
                </p>
              </div>
            </q-item>
          </h4>
        </q-item-label>
        <div class="emp-sidebg">
          <q-scroll-area style="height: calc(100vh - 220px);">
            <template v-for="(navigation, index) in navigations">
              <template v-if="navigation.sub === undefined">
                <q-item clickable v-bind:key="index"
                  :to="'/' + (navigation.moduleCode || selectedModule.code) + navigation.route" class="emp-nav-item">
                  <q-item-section avatar>
                    <i class="fa" :class="navigation.iconClass"></i>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label class="emp-nav-label">{{ navigation.name }}</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <template v-if="navigation.sub">
                <q-expansion-item v-bind:key="index" :label="navigation.name" dense-toggle expand-separator
                  :content-inset-level="0.5" :class="[qExpandItem, navigation.textColor, 'emp-expansion']">
                  <q-item clickable v-for="(sub, x) in navigation.sub" v-bind:key="x"
                    :to="'/' + (sub.moduleCode || navigation.moduleCode || selectedModule.code) + sub.route"
                    :class="[sub.textColor, 'emp-nav-sub']" active-class="emp-nav-active">
                    <q-item-section avatar>
                      <i class="fa" :class="sub.iconClass"></i>
                    </q-item-section>
                    <q-item-section>
                      <q-item-label>
                        <span>{{ sub.name }}</span>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </q-expansion-item>
              </template>

            </template>

            <q-item clickable :to="'/' + selectedModule.code + '/my-sanctions'"
              v-if="selectedModule.code === 'employee'" class="emp-nav-item">
              <q-item-section>
                <q-item-label class="emp-nav-label">Sanctions</q-item-label>
              </q-item-section>
            </q-item>

            <q-item clickable :to="'/' + selectedModule.code + '/my-onboarding'"
              v-if="selectedModule.code === 'employee'" class="emp-nav-item">
              <q-item-section>
                <q-item-label class="emp-nav-label">My Onboarding</q-item-label>
              </q-item-section>
            </q-item>

            <q-item clickable :to="'/' + selectedModule.code + '/documents'" v-if="selectedModule.code === 'employee'"
              class="emp-nav-item">
              <q-item-section>
                <q-item-label class="emp-nav-label">My Documents</q-item-label>
              </q-item-section>
            </q-item>

            <q-item clickable :to="{ name: 'PrivacyPolicy' }" class="emp-nav-item">
              <q-item-section>
                <q-item-label class="emp-nav-label">Privacy Policy</q-item-label>
              </q-item-section>
            </q-item>

          </q-scroll-area>
        </div>
      </q-list>
    </q-drawer>
    <q-page-container class="emp-page-container">
      <vue-page-transition name="fade-in-left">
        <router-view style="background-color: var(--hris-bg);" />
      </vue-page-transition>
      <ChangePassword></ChangePassword>
      <Profile></Profile>
      <LogoutDialog></LogoutDialog>

      <!-- conversation start here -->
      <!--<ChatModal></ChatModal>-->
      <!-- conversation end here -->
    </q-page-container>
  </q-layout>
</template>
<script>
import axios from 'axios';
import ChangePassword from '../components/ChangePassword.vue';
import Profile from '../components/Profile.vue';
import LogoutDialog from '../components/LogoutDialog.vue';
import jsPDF from 'jspdf';
//import ChatModal from '../components/announcement/AdminChatModal';

export default {
  name: 'Dashboard',
  components: {
    "ChangePassword": ChangePassword,
    "Profile": Profile,
    "LogoutDialog": LogoutDialog,
    //"ChatModal": ChatModal
  },

  data: () => ({
    isActive: false,
    selectedModule: {},
    isEmployee: true,
    leftDrawerOpen: true,
    navigations: [],
    subNavigations: [],
    qExpandItem: 'qExpandItem',
    showApprovals: false,
    fullname: null,
    allowedMenu: [],
    uniqueMenu: [],
    currentModule: '',
    moduleHeader: 'module-header',
    allUnread: 0,
    hrUnread: 0,
    notif_list: [],
    count: '',
    chat: [],
    chatNotif: 0,
    drawerRight: false,
    mychatmodal: true,
    chatEmployeeList: [],
    chatEmployeeTemp: [],
    sendToALl: { id: 0, empID: 'none', fullname: 'ANNOUNCEMENT', title: 'All Employees', type: 'all' },
    sendToHR: { id: 0, empID: 'none', fullname: 'HUMAN RESOURCES', title: 'HR Department', type: 'hr' },
    searchKey: '',
    drawerOpen: false,
    showMenu: false,
    currentTime: '',
    timeZone: null,
    apiUrl: process.env.VUE_APP_API_URL,
    employeeModules: null
  }),

  sockets: {
    totalNotif: function (data) {
      this.getChatNotification();
      this.getChatEmpList();
    },

    read_badge: function (data) {
      if (data.receiver != 0) {
        this.getChatEmpList();
      } else {
        this.getChatEmpList();
        //this.getChatSendAll();
      }
    },

    read_announcement: function (data) {
      this.count = this.count + 1;
    },
  },

  mounted: function () {
    if (this.$route.path === '/admin') {
      this.$router.push('/admin/dashboard');
    }

    if (this.$route.path == '/payslip/payslip-dashboard' || this.$route.path == '/payslip') {
      this.leftDrawerOpen = false;
    }
    if (this.userData.username == 'NewApplicant') {
      this.isEmployee = false;
      this.leftDrawerOpen = false;
      this.selectedModule.bgClass = '#353c48';
      this.$router.push('/recruitment/employment-application').catch(() => { });
    } else {
      this.fullname = this.userData.firstname + ' ' + this.userData.lastname
      for (let i in this.modules) {
        if (this.modules[i]['code'] == this.$route.params.module) {
          this.selectedModule = this.modules[i];
        }
      }
      this.getEmployeeModules();
      // this.setMenu(); //for navi menu
      this.currentModule = this.$route.params.module;
    }
  },

  created() {
    this.eventHub.$on('showChatModal', this.getChatEmpList);
    this.displayNotification();
    this.isChatViewer = (this.userData.department == 1 || this.userData.id == 1) ? true : false; //HR and ADMIN
    this.getTimeZone()
    this.timeInterval = setInterval(this.updateTime, 1000);
  },

  computed: {
    isDrawerOpen() {
      // Open the drawer for a specific named route
      return this.$route.name === 'dashboard'; // Replace with your named route
    }
  },

  methods: {
    //START:: CHAT
    showChatModal: function (obj) {
      this.eventHub.$emit('openChat', { stat: true, obj: obj });
    },

    filterEmployee: function () {
      if (this.searchKey !== null) {
        let formData = new FormData();
        formData.append("keyword", this.searchKey);
        axios.create({
          baseURL: this.apiUrl,
          headers: { 'Authorization': `Bearer ${this.token}` }
        }).post('/search/receiver', formData)
          .then((res) => {
            this.chatEmployeeList = res.data.data
          }).catch((error) => {
            console.log(error.response.status)
          });
      }
    },

    getChatEmpList: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      })
        .get(`/chat/employee/lists`)
        .then((res) => {
          this.chatEmployeeList = res.data.data;
          this.chatEmployeeTemp = res.data.data;
        })
    },

    readAnnouncement: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      })
        .get(`/employee/readAnnouncement`)
        .then((res) => {
          this.count = res.data.data;
        });
    },

    notificationBell: function () {
      //$router.replace('/announcement/announcement-list')
      const path = `/announcement/announcement-list`;
      if (this.$route.path !== path) {
        this.$router.push(path)
        location.reload();
      }
    },

    displayNotification: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      })
        .get(`/employee/notification`)
        .then((res) => {
          this.notif_list = res.data.data;
          //this.count = res.data.count;
        });
    },

    getChatNotification: function () {
      axios.create({
        baseURL: this.apiUrl,
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      })
        .get(`/employee/chat/notif`)
        .then((res) => {
          this.allUnread = 0 //(res.data.allUnread.totalAllUnread == '') ? 0 : res.data.allUnread.totalAllUnread
          this.hrUnread = res.data.hrUnread.totalHRUnread
          this.chatNotif = res.data.data.totalUnread
        });
    },

    selectMenu: function (module) {
      this.$router.replace('/' + module)
      location.reload();
    },

    setMenu: function () {
      const menuList = this.modules //get menu list
      const allowedMenu = this.userData //get allowed menu in token
      let isAdmin = (this.usersModules[1] !== undefined) ? true : false;
      if (isAdmin) {
        this.allowedMenu = menuList
      } else {
        for (let i in menuList) {
          if (menuList[i]['allowedmenu'] == 'forms' || menuList[i]['allowedmenu'] == 'leaves' || menuList[i]['allowedmenu'] == 'announcement' || menuList[i]['allowedmenu'] == 'payslip') { //make form and leaves default
            this.allowedMenu.push(menuList[i]);
          }
          for (let key in allowedMenu.modules) {
            if (menuList[i]['allowedmenu'] === allowedMenu.modules[key]['name']) {
              this.allowedMenu.push(menuList[i]);
            }
          }
        }
      }

      var unique = this.allowedMenu.filter(function (elem, index, self) { //remove duplicate menu
        return index === self.indexOf(elem);
      })

      this.uniqueMenu = unique;
    },

    logOut: function () {
      this.eventHub.$emit('logOut', { status: true });
    },

    changePassword: function () {
      this.eventHub.$emit('changePassword', { status: true });
    },

    myProfile: function () {
      this.eventHub.$emit('myProfile', { status: true });
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

    handleOption(option) {
      // Handle menu item click
      this.$q.notify({
        message: `${option} clicked!`,
        color: 'primary',
        position: 'top',
      });
      this.showMenu = false;
    },

    getEmployeeModules() {
      axios.create({
        baseURL: this.apiUrl,
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      })
        .post(`/employees/get/modules`)
        .then((res) => {
          // Use rawData if available as it contains full structure including icons
          this.employeeModules = res.data.rawData || res.data.data;
          this.setNav();
        });
    },

    setNav: function () {
      const uniqueNavigations = new Set();
      const userSaasFlag = this.userData && (this.userData.is_saas_owner ?? this.userData.is_sass_owner);
      const isSaasOwner = Boolean(userSaasFlag);
      // links for admin
      const defaultLinks = {
        "employees": {
          textColor: "navTitle",
          activeColor: "navTitle",
          iconClass: "fa-user",
          name: "Employee Management",
          route: "/sms-blast",
          sub: [
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-chart-bar',
              name: "Dashboard",
              route: "/dashboard"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-user-plus',
              name: "Create Employee",
              route: "/create"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-user-tie',
              name: "Create User",
              route: "/create/user"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-users',
              name: "List of Employees",
              route: "/list"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-calendar',
              name: "Scheduling",
              route: "/schedule-list"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-user-tag',
              name: "Hold Employees",
              route: "/hold-employees"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-user-times',
              name: "Inactive Employees",
              route: "/inactive-employees"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-user-lock',
              name: "Module Permissions",
              route: "/module-permissions"
            },
            // {
            //   textColor: 'colorEmployee',
            //   activeColor: 'activeColorEmployee',
            //   iconClass: 'fa-user-tie',
            //   name: "Change Employer Name",
            //   route: "/employer-name"
            // },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-user-edit",
              name: "Employee Logs",
              route: "/employee-logs",
            },
            // 06072022
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-user-edit",
              name: "For Review",
              route: "/for-review",
            },
            // 01092023
            // {
            //   textColor: "colorEmployee",
            //   activeColor: "activeColorEmployee",
            //   iconClass: "fa-user-lock",
            //   name: "New Applicants",
            //   route: "/new-employee",
            // },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-podcast',
              name: "Form",
              route: "/exit-interview"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-file-excel',
              name: "Report",
              route: "/exit-interview-report"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-gavel',
              name: "Employee Sanctions",
              route: "/sanctions"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-user-plus',
              name: "Employee Onboarding",
              route: "/onboarding"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-chart-line',
              name: "Performance Management",
              route: "/performance"
            },
            {
              textColor: 'colorEmployee',
              activeColor: 'activeColorEmployee',
              iconClass: 'fa-folder-open',
              name: "Documents",
              route: "/documents"
            },
          ],
        },

        "recruitment": {
          textColor: "navTitle",
          activeColor: "navTitle",
          iconClass: "fa-address-book",
          name: "Recruitment",
          moduleCode: "recruitment",
          route: "/dashboard-list",
          sub: [
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-chart-line",
              name: "Recruitment Dashboard",
              moduleCode: "recruitment",
              route: "/dashboard-list"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-clipboard-list",
              name: "Applicant Tracking",
              moduleCode: "recruitment",
              route: "/applicant-tracking"
            }
          ]
        },

        "payRoll": {
          textColor: "colorEmployee",
          activeColor: "activeColorEmployee",
          iconClass: "fa-money-bill",
          name: "Payroll",
          route: "/sms-blast",
          sub: [
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-chart-pie',
              name: "Overview",
              route: "/overview"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-file-invoice-dollar',
              name: "Process Payroll",
              route: "/process"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-file-invoice-dollar',
              name: "Payroll",
              route: "/payroll-history"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-calendar-plus',
              name: "Adjustment/Deduction",
              route: "/adjusments"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-calendar-minus',
              name: "Loan Deduction",
              route: "/deductions"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-newspaper',
              name: "Detailed Payslip",
              route: "/detailed-payslip"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "SSS",
              route: "/sss-table"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "PhilHealth",
              route: "/philHealth-table"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Pag-ibig",
              route: "/pagibig-table"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Tax-Table",
              route: "/tax-table"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-calendar-check',
              name: "Government Deduction Schedule",
              route: "/government-deduction-schedule"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Tax Status",
              route: "/tax-status-table"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Holiday & OT Rates",
              route: "/holiday-otrates-table"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "13th Month Payslip",
              route: "/thirteenth-month"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-file-invoice-dollar',
              name: "Cash Bond Management",
              route: "/cash-bond-management"
            },
          ]
        },

        "timeKeeping": {
          textColor: "colorEmployee",
          activeColor: "activeColorEmployee",
          iconClass: "fa-clock",
          name: "Timekeeping",
          route: "/sms-blast",
          sub: [
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-chart-bar',
              name: "Dashboard",
              route: "/home/dashboard"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-user-clock',
              name: "Timelogs",
              route: "/timelogs/upload"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-stopwatch',
              name: "Monthly Detailed TK",
              route: "/detailed/tk"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-clock',
              name: "Hourly Detailed TK",
              route: "/hourly/detailed/tk"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-file-invoice-dollar',
              name: "TK Summary",
              route: "/tk/summary"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-user-clock',
              name: "TK Pending Request",
              route: "/tk/pending/request"
            },
            // {
            //   textColor: 'colorEmployee',
            //   activeColor: "activeColorEmployee",
            //   iconClass: 'fa-calendar-alt',
            //   name: "TK Request History",
            //   route: "/tk/request/history"
            // },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-gifts',
              name: "Holidays",
              route: "/holidays"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-calendar-alt',
              name: "Periodic Table",
              route: "/periodic/table"
            },
          ]
        },

        "leaves": {
          textColor: "colorEmployee",
          activeColor: "activeColorEmployee",
          iconClass: "fa-person-walking-arrow-right",
          name: "Leaves",
          route: "/",
          sub: [
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-copy',
              name: "My Applications",
              route: "/my-leave-applications"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-file-alt',
              name: "Application Form",
              route: "/application-form"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-ol',
              name: "My Leave Credits",
              route: "/my-leave-credits"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-user-check',
              name: "Employee Leaves",
              route: "/my-leave-approvals"
            },
            // {
            //   textColor: "colorEmployee",
            //   activeColor: "activeColorEmployee",
            //   iconClass: 'fa-user-edit',
            //   name: "Set Approvers",
            //   route: "/set-leave-approvers"
            // },
            //{
            //  textColor: "colorEmployee",
            //  activeColor: "activeColorEmployee",
            //  iconClass: 'fa-folder-open',
            //  name: "Employee Applications",
            //  route: "/employee-leave-applications"
            //},
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list',
              name: "Employee Leave Credits",
              route: "/employee-leave-credits"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-file-contract',
              name: "Special Leave Applications",
              route: "/special-leave-applications"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-chart-bar',
              name: "Leave Reports",
              route: "/leave-reports"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-file-contract',
              name: "Remaining Leaves",
              route: "/remaining-leaves"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-history',
              name: "Employee Leave History",
              route: "/employee-leave-history"
            },
          ]
        },

        "training": {
          textColor: "colorEmployee",
          activeColor: "activeColorEmployee",
          iconClass: "fa-graduation-cap",
          name: "Training",
          route: "/sms-blast",
          sub: [
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-book-open',
              name: "E-Learning",
              route: "/lessons"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-chalkboard-teacher',
              name: "Learning & Development",
              route: "/training-dashboard"
            },
            {
              textColor: 'colorEmployee',
              activeColor: "activeColorEmployee",
              iconClass: 'fa-certificate',
              name: "Certifications",
              route: "/certifications"
            },
          ]
        },

        "announcement": {
          textColor: "colorEmployee",
          activeColor: "activeColorEmployee",
          iconClass: "fa-bullhorn",
          name: "Announcement",
          route: "/",
          sub: [
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-chart-bar',
              name: "Admin Dashboard",
              route: "/admin-dashboard"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-bullhorn',
              name: "List of Announcements",
              route: "/announcement-list"
            }
          ]
        },

        "backend": {
          textColor: "colorEmployee",
          activeColor: "activeColorEmployee",
          iconClass: "fa-code",
          name: "Government Reports",
          route: "/",
          sub: [
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "SSS Employee Contribution",
              route: "/sss-employee-contribution"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Philhealth Employee Contribution",
              route: "/philhealth-employee-contribution"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Pag-ibig Employee Contribution",
              route: "/pagibig-employee-contribution"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Alphalist",
              route: "/alphalist"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: 'fa-list-alt',
              name: "Total Gov Contribution",
              route: "/total-gov-contribution"
            },
            {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-table",
              name: "2316 Signatory",
              route: "/form-2316",
            },
          ]
        },

        "settings": {
          "textColor": "colorEmployee",
          "activeColor": "activeColorEmployee",
          "iconClass": "fa-gear",
          "name": "Settings",
          "route": "/",
          "sub": [
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-chart-pie",
              "name": "SaaS Dashboard",
              "route": "/saas/dashboard"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Accounts",
              "route": "/account/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Accountability",
              "route": "/accountability/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Adjustment",
              "route": "/adjustment/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Banks",
              "route": "/bank/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Branches",
              "route": "/branch/list"
            },

            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Civil Status",
              "route": "/civil-status/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Company",
              "route": "/company/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Cost Center",
              "route": "/cost-center/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Coverage",
              "route": "/coverage/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Courses",
              "route": "/course/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Deactivation Reasons",
              "route": "/deactivation-reasons/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Deduction",
              "route": "/deduction/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Departments",
              "route": "/department/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Division Head",
              "route": "/division-head/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Employee Status",
              "route": "/status/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Employment Status",
              "route": "/employment-status/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Feature Management",
              "route": "/feature-management"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "GCA",
              "route": "/gca/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Immediate Head",
              "route": "/immediate-head/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Locations",
              "route": "/location/list"
            },
            // {
            //   "textColor": "colorEmployee",
            //   "activeColor": "activeColorEmployee",
            //   "iconClass": "fa-users-cog",
            //   "name": "Module Permissions Access",
            //   "route": "/module-permissions-access"
            // },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "MWE-Daily",
              "route": "/mwe-daily/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "MWE-Monthly",
              "route": "/mwe-monthly/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-id-card",
              "name": "NFC Tags",
              "route": "/nfc/tags"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-gavel",
              "name": "Offense Types",
              "route": "/offense-types/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Payclass",
              "route": "/payclass/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Payment Mode",
              "route": "/payment-mode/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Payroll Groups",
              "route": "/payroll-groups/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Person to Notify Relationship",
              "route": "/relationship/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Positions",
              "route": "/position/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Provinces",
              "route": "/province/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Ranks",
              "route": "/rank/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Region",
              "route": "/region/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Sector/Industry",
              "route": "/sector/list"
            },
            // {
            //   "textColor": "colorEmployee",
            //   "activeColor": "activeColorEmployee",
            //   "iconClass": "fa-users-cog",
            //   "name": "Set As Approver",
            //   "route": "/set-as-approver"
            // },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-users-cog",
              "name": "Tax Status",
              "route": "/tax-status/list"
            },
            {
              "textColor": "colorEmployee",
              "activeColor": "activeColorEmployee",
              "iconClass": "fa-building",
              "name": "Tenant Enrollment",
              "route": "/tenant/enrollment"
            },
          ]
        },
      };

      const roleId = Number(this.userData.role_id);
      const isSuperAdmin = roleId === 0;
      const rawCompanyId = this.userData.company_id ?? this.userData.company ?? 0;
      const companyId = Number(rawCompanyId) || 0;
      const hideForNonAdmin = ![0, 1].includes(roleId);
      const hideForCompany = !isSuperAdmin && companyId !== 1;
      const canViewSaasDashboard = isSaasOwner || isSuperAdmin;

      if (hideForNonAdmin || hideForCompany) {
        defaultLinks.settings.sub = defaultLinks.settings.sub.filter(item => item.route !== '/feature-management');
      }
      if (!canViewSaasDashboard) {
        defaultLinks.settings.sub = defaultLinks.settings.sub.filter(item => item.route !== '/saas/dashboard');
      }


      if (this.userData.role_id == 1 || this.userData.role_id == 0) {
        this.selectedModule.code = this.selectedModule.code || this.$route.params.module || 'admin'
        for (let i in defaultLinks) {
          this.navigations.push(defaultLinks[i]);
          if (this.$route.name == "Dashboard" && this.selectedModule.code === 'admin') {
            this.$router.push('/admin/dashboard');
          }
        }
        // }else if(this.userData.role_id == 0){
        //   this.selectedModule.code = 'superAdmin'
        //   for (let i in defaultLinks) {
        //       if (this.$route.name == "Dashboard") {
        //         this.$router.push('/employee-management/dashboard');
        //       }
        //       if (!uniqueNavigations.has(defaultLinks[i].name)) {
        //         this.navigations.push(defaultLinks[i]);
        //         uniqueNavigations.add(defaultLinks[i].name);
        //       }
        //       if (!uniqueNavigations.has(superAdminOnly.settings.name)) {
        //         this.navigations.push(superAdminOnly.settings);
        //         uniqueNavigations.add(superAdminOnly.settings.name);
        //       }
        //   }
      } else {
        this.selectedModule.code = 'employee';
        if (this.$route.path !== '/employee/attendance') {
          this.$router.push('/employee/attendance');
        }


        if (this.employeeModules) {
          let employeeModules = this.employeeModules;
          if (typeof employeeModules === 'string') {
            try {
              employeeModules = JSON.parse(employeeModules);
            } catch (e) {
              employeeModules = [];
            }
          }

          const filteredModules = (Array.isArray(employeeModules) ? employeeModules : [])
            .filter(item => item.enabled)
            .map(item => {
              const subItems = item.sub || item.sub_modules || [];
              return {
                ...item,
                sub: subItems
                  .filter(subItem => subItem.enabled)
                  .filter(subItem => subItem.route !== '/total-gov-contribution')
              };
            });

          for (let i in filteredModules) {
            this.navigations.push(filteredModules[i]);
          }
        } else {
          let mods = {
            "timeKeeping": {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-clock",
              name: "Timekeeping and Forms",
              route: "/sms-blast",
              sub: [
                {
                  textColor: 'colorEmployee',
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-user',
                  name: "Attendance",
                  route: "/attendance"
                },
                {
                  textColor: 'colorEmployee',
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-calendar',
                  name: "Calendar",
                  route: "/calendar"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-calendar-times',
                  name: "Change of Work Schedule",
                  route: "/change-schedule"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-history',
                  name: "Half Day",
                  route: "/halfday"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-plane',
                  name: "Official Business Trip",
                  route: "/business-trip"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-stopwatch',
                  name: "Overtime",
                  route: "/overtime"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-history',
                  name: "Undertime",
                  route: "/undertime"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-laptop-house',
                  name: "Work From Home",
                  route: "/wfh"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: "fa-table",
                  name: "2316 Signatory",
                  route: "/form-2316",
                },
              ]
            },

            "training": {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-graduation-cap",
              name: "Training",
              route: "/sms-blast",
              sub: [
                {
                  textColor: 'colorEmployee',
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-book-open',
                  name: "E-Learning",
                  route: "/lessons"
                },
                {
                  textColor: 'colorEmployee',
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-chalkboard-teacher',
                  name: "Learning & Development",
                  route: "/training-dashboard"
                },
                {
                  textColor: 'colorEmployee',
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-certificate',
                  name: "Certifications",
                  route: "/certifications"
                },
              ]
            },

            "leaves": {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-person-walking-arrow-right",
              name: "Leaves",
              route: "/",
              sub: [
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-copy',
                  name: "My Applications",
                  route: "/my-leave-applications"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-file-alt',
                  name: "Application Form",
                  route: "/application-form"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-list-ol',
                  name: "My Leave Credits",
                  route: "/my-leave-credits"
                },
                //{
                //textColor: "colorEmployee",
                //activeColor: "activeColorEmployee",
                //iconClass: 'fa-file-contract',
                //name: "Remaining Leaves",
                //route: "/remaining-leaves"
                //},
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-history',
                  name: "My Leave History",
                  route: "/employee-leave-history"
                },
              ]
            },

            "government-reports": {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-code",
              name: "Government Reports",
              route: "/",
              sub: [
                // {
                //   textColor: "colorEmployee",
                //   activeColor: "activeColorEmployee",
                //   iconClass: 'fa-code',
                //   name: "Backend Dashboard",
                //   route: "/backend-list"
                // },
                // {
                //   textColor: "colorEmployee",
                //   activeColor: "activeColorEmployee",
                //   iconClass: 'fa-list-alt',
                //   name: "Vertical Detailed",
                //   route: "/vertical-summary"
                // },
                // {
                //   textColor: "colorEmployee",
                //   activeColor: "activeColorEmployee",
                //   iconClass: 'fa-newspaper',
                //   name: "Detailed Payslip",
                //   route: "/detailed-payslip"
                // },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-list-alt',
                  name: "SSS Employee Contribution",
                  route: "/sss-employee-contribution"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-list-alt',
                  name: "Philhealth Employee Contribution",
                  route: "/philhealth-employee-contribution"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-list-alt',
                  name: "Pag-ibig Employee Contribution",
                  route: "/pagibig-employee-contribution"
                },
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-list-alt',
                  name: "Alphalist",
                  route: "/alphalist"
                },
              ]
            },

            "announcement": {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-bullhorn",
              name: "Announcement",
              route: "/",
              sub: [
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-bullhorn',
                  name: "List of Announcements",
                  route: "/announcement-list"
                }
              ]
            },
            "loan": {
              textColor: "colorEmployee",
              activeColor: "activeColorEmployee",
              iconClass: "fa-money-bill-wave",
              name: "Loans",
              route: "/",
              sub: [
                {
                  textColor: "colorEmployee",
                  activeColor: "activeColorEmployee",
                  iconClass: 'fa-file-invoice-dollar',
                  name: "My Loan Applications",
                  route: "/my-loan-applications"
                }
              ]
            }
          };

          for (let i in mods) {
            this.navigations.push(mods[i]);
          }
        }
      }

      const hideEmployeeAdminLinks = !(isSaasOwner || isSuperAdmin);
      if (hideEmployeeAdminLinks) {
        defaultLinks.employees.sub = defaultLinks.employees.sub.filter(sub => !['/create/user', '/feature-management'].includes(sub.route));
      }

      const showCompanySettings = isSaasOwner || isSuperAdmin || Number(this.userData.role_id) === 1;
      if (!showCompanySettings) {
        defaultLinks.settings.sub = defaultLinks.settings.sub.filter(sub => sub.route !== '/company/list');
      }

      const showTenantEnrollment = isSaasOwner || isSuperAdmin;
      if (!showTenantEnrollment) {
        defaultLinks.settings.sub = defaultLinks.settings.sub.filter(sub => sub.route !== '/tenant/enrollment');
      }
    },

    updateTime() {
      const date = new Date();
      const options = this.timeZone ? { timeZone: this.timeZone } : {};
      this.currentTime = date.toLocaleTimeString('en-US', options);
    },

    async getTimeZone() {
      try {
        axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
          .get('/current-time')
          .then((res) => {
            this.timeZone = res.data.time_zone;
          })
      } catch (error) {
        this.currentTime = 'Error fetching time'; // Handle error scenario
      }
    }
  },

  beforeDestroy() {
    // Clear the interval when the component is destroyed
    clearInterval(this.timeInterval);
  }
};
</script>
<style scoped>
.qExpandItem {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.module-header {
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.menu-header {
  color: #FFF;
  text-shadow: -1px -1px #888,
    1px -1px 0 #888,
    -1px 1px 0 #888,
    1px 1px 0 #888;
}

.navTitle {
  color: black;
}

.colorEmployee {
  color: black;
  font-weight: 300;
}

.activeColorEmployee {
  color: #1E88E5;
  background-color: white;
  text-shadow: none;
}

.activeColorEmployee::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
  font-weight: bold;
}

.colorPayroll {
  color: #2E7D32;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorPayroll {
  color: white;
  background-color: #2E7D32;
  text-shadow: none;
}

.activeColorPayroll::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorTimeKeep {
  color: #546E7A;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorTimeKeep {
  color: white;
  background-color: #546E7A;
  text-shadow: none;
}

.activeColorTimeKeep::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorOnlineForms {
  color: #E53935;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorOnlineForms {
  color: white;
  background-color: #E53935;
  text-shadow: none;
}

.activeColorOnlineForms::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorSettings {
  color: #212121;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorSettings {
  color: white;
  background-color: #212121;
  text-shadow: none;
}

.activeColorSettings::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorRecruitment {
  color: #3F51B5;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorRecruitment {
  color: white;
  background-color: #3F51B5;
  text-shadow: none;
}

.activeColorRecruitment::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorAnnouncement {
  color: #E65100;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorAnnouncement {
  color: white;
  background-color: #E65100;
  text-shadow: none;
}

.activeColorAnnouncement::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorBackend {
  color: #827717;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorBackend {
  color: white;
  background-color: #827717;
  text-shadow: none;
}

.activeColorBackend::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorSettings {
  color: #d50000;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorSettings {
  color: white;
  background-color: #d50000;
  text-shadow: none;
}

.activeColorSettings::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.colorPantry {
  color: #c51162;
  text-shadow: -1px -1px #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF,
    1px 1px 0 #FFF;
}

.activeColorPantry {
  color: white;
  background-color: #c51162;
  text-shadow: none;
}

.activeColorPantry::after {
  font-family: "Font Awesome 5 Free";
  font-size: 20px;
  font-weight: 900;
  content: "\f0da";
  margin-top: 3px;
}

.q-bt {
  background-color: "black";
}

.sidebg {
  /* background: url('../assets/bgcrop-2.png') !important; */
  /* background-size: cover !important;
  background-repeat: no-repeat !important; */
  /*background-attachment: fixed;*/
  opacity: 1;
  top: 300px;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
}

/*START:: FOR NOTIFICATION*/
.notif-title {
  margin-left: 15px;
  margin-top: 15px;
}

.item-list {
  margin: 0;
  font-size: 18px;
  line-height: 1.2em;
}

.item-dt {
  line-height: 2em;
  margin-bottom: 0;
}

/*END:: FOR NOTIFICATION*/

/* ===== Employee shell — elegant enterprise (Admin unchanged) ===== */
.is-employee-shell {
  font-family: var(--hris-font);
  -webkit-font-smoothing: antialiased;
}

.is-employee-shell .emp-header {
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: var(--hris-text);
  box-shadow: none;
  border-bottom: 1px solid var(--hris-border-light);
}

.is-employee-shell .emp-toolbar {
  min-height: 64px;
  padding: 0 16px 0 8px;
}

.is-employee-shell .emp-clock {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}

.is-employee-shell .emp-clock-time {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 600;
  color: var(--hris-text);
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

.is-employee-shell .emp-clock-tz {
  margin: 2px 0 0;
  font-size: 0.6875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--hris-text-muted);
}

.is-employee-shell .emp-avatar-wrap {
  padding: 8px 4px 8px 8px;
}

.is-employee-shell .emp-avatar-wrap .q-avatar {
  box-shadow: 0 0 0 2px var(--hris-surface), 0 0 0 3px var(--hris-border);
  transition: box-shadow 0.2s;
  background: #E8EAED;
}

.is-employee-shell .emp-avatar-wrap .q-avatar:hover {
  box-shadow: 0 0 0 2px var(--hris-surface), 0 0 0 3px var(--hris-accent);
}

.is-employee-shell .emp-profile-avatar-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.is-employee-shell .emp-notif-badge {
  background: var(--hris-accent) !important;
  color: #fff !important;
  font-weight: 600;
  font-size: 0.65rem;
  min-width: 16px;
  padding: 0 4px;
}

.is-employee-shell .emp-drawer {
  background: var(--hris-surface);
  border-right: 1px solid var(--hris-border-light);
  box-shadow: 4px 0 24px rgba(26, 31, 46, 0.03);
}

.is-employee-shell .emp-drawer-list {
  border: none;
}

.is-employee-shell .emp-drawer-profile {
  background: linear-gradient(165deg,
      rgba(47, 143, 98, 0.07) 0%,
      rgba(47, 143, 98, 0.02) 45%,
      var(--hris-surface) 100%);
  padding: 28px 20px 20px;
  border-bottom: 1px solid var(--hris-border-light);
}

.is-employee-shell .emp-profile-item {
  cursor: default;
  padding: 0;
  align-items: center;
}

.is-employee-shell .emp-company-name {
  width: 100%;
  text-align: center;
}

.is-employee-shell .emp-company-name p {
  margin: 0 0 16px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--hris-accent);
}

.is-employee-shell .emp-profile-avatar-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
}

.is-employee-shell .emp-profile-avatar {
  border-radius: 50%;
  border: 3px solid var(--hris-surface);
  box-shadow: 0 0 0 1px var(--hris-border), var(--hris-shadow);
  object-fit: cover;
  background: #E8EAED;
  display: block;
}

.is-employee-shell .emp-profile-name {
  margin: 14px 0 4px;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--hris-text);
}

.is-employee-shell .emp-profile-role {
  margin: 0;
  display: inline-block;
  font-size: 0.6875rem;
  color: var(--hris-accent);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  background: var(--hris-accent-soft);
  padding: 4px 10px;
  border-radius: 999px;
}

.is-employee-shell .emp-sidebg {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  opacity: 1;
  padding: 12px 0 28px;
}

.is-employee-shell .emp-nav-item,
.is-employee-shell .emp-nav-sub {
  border-radius: var(--hris-radius-sm);
  margin: 2px 10px;
  min-height: 42px;
  color: var(--hris-text-secondary);
  transition: background 0.2s, color 0.2s;
}

.is-employee-shell .emp-nav-item:hover,
.is-employee-shell .emp-nav-sub:hover {
  background: var(--hris-surface-muted);
  color: var(--hris-text);
}

.is-employee-shell .emp-nav-item .q-item__section--avatar,
.is-employee-shell .emp-nav-sub .q-item__section--avatar {
  min-width: 36px;
  color: var(--hris-text-muted);
}

.is-employee-shell .emp-nav-label {
  font-weight: 500;
  font-size: 0.875rem;
  color: inherit;
  letter-spacing: -0.01em;
}

.is-employee-shell .emp-expansion {
  color: var(--hris-text);
  margin: 4px 0;
}

.is-employee-shell .emp-expansion>>>.q-expansion-item__container>.q-item,
.is-employee-shell .emp-expansion ::v-deep .q-expansion-item__container>.q-item {
  margin: 0 10px;
  border-radius: var(--hris-radius-sm);
  min-height: 42px;
}

.is-employee-shell .emp-expansion>>>.q-item__label,
.is-employee-shell .emp-expansion ::v-deep .q-item__label {
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--hris-text-muted);
}

.is-employee-shell .emp-nav-active {
  background: var(--hris-accent-soft) !important;
  color: var(--hris-accent) !important;
  text-shadow: none;
  font-weight: 600;
}

.is-employee-shell .emp-nav-active .q-item__section--avatar {
  color: var(--hris-accent) !important;
}

.is-employee-shell .emp-nav-active::after {
  content: none;
}

.is-employee-shell .emp-page-container {
  background: var(--hris-bg);
}

.is-employee-shell .colorEmployee,
.is-employee-shell .colorPayroll,
.is-employee-shell .colorTimeKeep,
.is-employee-shell .colorOnlineForms,
.is-employee-shell .colorSettings,
.is-employee-shell .colorRecruitment,
.is-employee-shell .colorAnnouncement,
.is-employee-shell .colorBackend,
.is-employee-shell .colorPantry {
  color: var(--hris-text-secondary);
  font-weight: 500;
  text-shadow: none;
}

.is-employee-shell .activeColorEmployee,
.is-employee-shell .activeColorPayroll,
.is-employee-shell .activeColorTimeKeep,
.is-employee-shell .activeColorOnlineForms,
.is-employee-shell .activeColorSettings,
.is-employee-shell .activeColorRecruitment,
.is-employee-shell .activeColorAnnouncement,
.is-employee-shell .activeColorBackend,
.is-employee-shell .activeColorPantry {
  background: transparent;
  color: inherit;
  text-shadow: none;
}

.is-employee-shell .activeColorEmployee::after,
.is-employee-shell .activeColorPayroll::after,
.is-employee-shell .activeColorTimeKeep::after,
.is-employee-shell .activeColorOnlineForms::after,
.is-employee-shell .activeColorSettings::after,
.is-employee-shell .activeColorRecruitment::after,
.is-employee-shell .activeColorAnnouncement::after,
.is-employee-shell .activeColorBackend::after,
.is-employee-shell .activeColorPantry::after {
  content: none;
}
</style>

<style>
/* Non-scoped menu popup (teleported) for employee shell */
.emp-user-menu {
  border-radius: var(--hris-radius) !important;
  box-shadow: var(--hris-shadow-lg) !important;
  border: 1px solid var(--hris-border-light);
  overflow: hidden;
  padding: 6px 0 !important;
}

.emp-user-menu .q-item {
  min-height: 44px;
  color: var(--hris-text);
  margin: 0 6px;
  border-radius: var(--hris-radius-sm);
  font-size: 0.875rem;
  font-weight: 500;
}

.emp-user-menu .q-item:hover {
  background: var(--hris-accent-soft);
  color: var(--hris-accent);
}
</style>
